import type {IAppDispatch, IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {AuthActionType} from "../types/AuthActionType";
import {authSucceeded, IAuthSucceededPayload} from "./auth_succeeded_event";

interface IConfirmSmsLoginSessionParams {
    getAuthPayload: (state: IRootState) => Pick<IAuthSucceededPayload, "userSource" | "gtmSourceSection">;
    onSessionConfirmed?: () => void;
}

export const confirmSmsLoginSession =
    ({getAuthPayload, onSessionConfirmed}: IConfirmSmsLoginSessionParams) =>
    async (dispatch: IAppDispatch, getState: () => IRootState): Promise<boolean> => {
        const isAuthenticated = await dispatch(
            getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.initiate(undefined, {forceRefetch: true, subscribe: false})
        ).unwrap();

        if (!isAuthenticated) {
            return false;
        }

        const authPayload = getAuthPayload(getState());

        onSessionConfirmed?.();
        dispatch(authSucceeded({type: AuthActionType.LOGIN, ...authPayload, registrationMethod: "sms"}));

        return true;
    };
import type {IAppDispatch, IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../../user/api/get_is_user_authenticated";
import {AuthActionType} from "../types/AuthActionType";
import {authSucceeded, IAuthSucceededPayload} from "./auth_succeeded_event";

interface IConfirmSmsLoginSessionParams {
    getAuthPayload: (state: IRootState) => Pick<IAuthSucceededPayload, "userSource" | "gtmSourceSection">;
    onSessionConfirmed?: () => void;
}

export const confirmSmsLoginSession =
    ({getAuthPayload, onSessionConfirmed}: IConfirmSmsLoginSessionParams) =>
    async (dispatch: IAppDispatch, getState: () => IRootState): Promise<boolean> => {
        const isAuthenticated = await dispatch(
            getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.initiate(undefined, {forceRefetch: true, subscribe: false})
        ).unwrap();

        if (!isAuthenticated) {
            return false;
        }

        const authPayload = getAuthPayload(getState());

        onSessionConfirmed?.();
        dispatch(authSucceeded({type: AuthActionType.LOGIN, ...authPayload, registrationMethod: "sms"}));

        return true;
    };
